// VaultBridge palette — locked in Round 03 (Stacked Plates Refinement)
export const theme = {
  colors: {
    // Brand
    ink: "#0F2547",        // Vault Navy — primary ink
    accent: "#7B8FA8",     // Steel — accent
    paper: "#F2F4F7",      // Mist — paper / light surface
    paperWarm: "#EFEEE8",  // Warm paper alt
    dark: "#08152B",       // Hull — dark mode background

    // Functional aliases
    text: "#0F2547",
    textMuted: "rgba(15, 37, 71, 0.7)",
    textOnDark: "#E5EAF2",
    textOnDarkMuted: "rgba(229, 234, 242, 0.75)",
    headings: "#0F2547",
    background: "#F2F4F7",
    backgroundAlt: "#FFFFFF",
    border: "rgba(15, 37, 71, 0.12)",
    borderOnDark: "rgba(229, 234, 242, 0.15)",
  },
  fonts: {
    body: "'Inter', system-ui, -apple-system, 'Helvetica Neue', sans-serif",
    heading: "'Inter', system-ui, -apple-system, 'Helvetica Neue', sans-serif",
    mono: "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
  },
  breakpoints: {
    xs: "480px",
    sm: "768px",
    md: "992px",
    lg: "1200px",
    xl: "1440px",
  },
  spacing: {
    xxs: "0.25rem",
    xs: "0.5rem",
    sm: "1rem",
    md: "2rem",
    lg: "3rem",
    xl: "5rem",
    xxl: "8rem",
  },
  radii: {
    none: "0",
    sm: "2px",
    md: "4px",
    lg: "8px",
  },
  transitions: {
    fast: "0.18s ease",
    normal: "0.3s ease",
  },
}
